import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from "vue3-cookies";
import globalComponents from "./global-components";
import utils from "./utils";
import "./libs";

// Midone Theme
import "./assets/sass/app.scss";

const app = createApp(App)
  .use(store)
  .use(VueCookies)
  .use(router);

globalComponents(app);
utils(app);

app.mount("#app");
